import { render, staticRenderFns } from "./ChangeCrypto.vue?vue&type=template&id=2c15e9a5&scoped=true"
import script from "./ChangeCrypto.vue?vue&type=script&lang=js"
export * from "./ChangeCrypto.vue?vue&type=script&lang=js"
import style0 from "./ChangeCrypto.vue?vue&type=style&index=0&id=2c15e9a5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15e9a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c15e9a5')) {
      api.createRecord('2c15e9a5', component.options)
    } else {
      api.reload('2c15e9a5', component.options)
    }
    module.hot.accept("./ChangeCrypto.vue?vue&type=template&id=2c15e9a5&scoped=true", function () {
      api.rerender('2c15e9a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/ChangeCrypto.vue"
export default component.exports